import { render, staticRenderFns } from "./InlineBoxRelatedFiles.vue?vue&type=template&id=6a046b08"
import script from "./InlineBoxRelatedFiles.vue?vue&type=script&lang=js"
export * from "./InlineBoxRelatedFiles.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxRelatedFiles.vue?vue&type=style&index=0&id=6a046b08&prod&lang=css"
import style1 from "./InlineBoxRelatedFiles.vue?vue&type=style&index=1&id=6a046b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports